// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":3,"societaId":1,"societa":{"id":1,"nome":"Smartix"},"codice":"BRICO","nome":"Bricocenter","note":null,"attivo":true,"_count":{"clienti":2,"codiciArticolo":40,"contratti":1,"premi":3}}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/anagrafiche/insegne/:id',
    requestBody: '{"codice":"BRICO","nome":"Bricocenter","note":null}',
    response: '{"id":3,"societaId":1,"codice":"BRICO","nome":"Bricocenter","note":null,"attivo":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/anagrafiche/insegne/:id',
    requestBody: null,
    response: '{"message":"Insegna disattivata"}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/insegne/:id/riattiva',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
